import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["id", "inline", "title", "titleWeight", "size", "fullWidth", "scrollable", "padded", "options", "value", "selectType", "onChange", "onChipClick", "dataTestId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import styles from './Chips.module.css';
import { ChipButton } from '../../internal/ChipButton';
import { generateDataTestId } from '../../../internal/utils';

/**
 * Компонент чипсов
 *
 * [Ссылка на макет](https://www.figma.com/design/5ReRnX2YL5jSW1Hpz2xGDU/%F0%9F%8C%90-Chip)
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ChipsComponent(_ref, ref) {
  let {
      id,
      inline,
      title,
      titleWeight = 'bold',
      size = 'M',
      fullWidth,
      scrollable,
      padded = true,
      options,
      value = [],
      selectType = 'single',
      onChange,
      onChipClick,
      dataTestId
    } = _ref,
    chipProps = _objectWithoutProperties(_ref, _excluded);
  const handleChange = React.useCallback(changedValue => (checked, event) => {
    if (selectType === 'single') {
      onChipClick === null || onChipClick === void 0 || onChipClick(changedValue, checked, event);
      onChange === null || onChange === void 0 || onChange(value.includes(changedValue) ? [] : [changedValue]);
      return;
    }
    if (selectType === 'multiple') {
      onChipClick === null || onChipClick === void 0 || onChipClick(changedValue, checked, event);
      const newValues = value.includes(changedValue) && !checked ? value.filter(value => value !== changedValue) : [...value, changedValue];
      onChange === null || onChange === void 0 || onChange(newValues);
      return;
    }
    if (selectType === 'oneOf') {
      if (changedValue === value[0]) {
        return;
      }
      onChipClick === null || onChipClick === void 0 || onChipClick(changedValue, checked, event);
      onChange === null || onChange === void 0 || onChange([changedValue]);
      return;
    }
  }, [onChange, onChipClick, selectType, value]);
  const handleChipClick = React.useCallback(event => {
    if (scrollable) {
      event.currentTarget.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  }, [scrollable]);
  return /*#__PURE__*/_jsxs("div", {
    id: id,
    className: clsx(styles['chips'], {
      [styles['chips--inline']]: inline,
      [styles['chips--fullWidth']]: fullWidth
    }),
    ref: ref,
    children: [title && /*#__PURE__*/_jsx("span", {
      className: clsx(styles['title'], {
        [styles['title--small']]: size === 'S',
        [styles['title--medium']]: size === 'M',
        [styles['title--bold']]: titleWeight === 'bold'
      }),
      "data-testid": generateDataTestId(dataTestId, ['title']),
      children: title
    }), /*#__PURE__*/_jsx("ul", {
      className: clsx(styles['content'], {
        [styles['content--wrap']]: !fullWidth && !scrollable,
        [styles['content--scrollable']]: !fullWidth && scrollable,
        [styles['content--padded']]: padded
      }),
      children: options.map((_ref2, index) => {
        let {
          label,
          value: optionValue,
          icon,
          leftIcon,
          counter,
          disabled,
          dataTestId: optionDataTestId,
          ref
        } = _ref2;
        return /*#__PURE__*/_jsx("li", {
          className: styles['item'],
          onClick: handleChipClick,
          ref: ref,
          children: /*#__PURE__*/_jsx(ChipButton, _objectSpread(_objectSpread({
            text: label,
            checked: value.includes(optionValue),
            icon: icon,
            leftIcon: leftIcon,
            counter: counter,
            onClick: handleChange(optionValue),
            size: size,
            dataTestId: optionDataTestId || generateDataTestId(dataTestId, [String(optionValue)])
          }, chipProps), {}, {
            disabled: disabled || chipProps.disabled
          }))
        }, index);
      })
    })]
  });
}
export const Chips = /*#__PURE__*/React.forwardRef(ChipsComponent);